/**
 * Vendored, minimal mirror of emmi-observability@70ae4c8c
 * (packages/event-schema/schemas/, packages/telemetry/src/sanitize.ts,
 * branch obs/phase4-tf — those packages are not published, see
 * usage-event-pipeline/Shared Client SDK). This file hardcodes only the
 * events this app actually emits; it is NOT a copy of the ajv-based
 * registry. Do not add an event name here without a matching
 * schemas/events/<name>/vN.json in emmi-observability first — the ingestion
 * endpoint rejects any event it does not also recognize.
 */

export type EmmiApp =
  | "emmi-frontend"
  | "emmi-app"
  | "emmi-back-office"
  | "emmi-tienda"
  | "emmi-games"
  | "emmiProfesores"
  | "emmiProfesoresDesktop";

export type EmmiPlatform = "web" | "ios" | "android" | "desktop";
export type EmmiLocale = "es-MX" | "en-US";

export interface FieldSpec {
  type: "boolean" | "integer" | "string";
  enum?: readonly string[];
  pattern?: RegExp;
  minimum?: number;
}

export interface EventSpec {
  version: number;
  anonymousAllowed: boolean;
  required: readonly string[];
  properties: Record<string, FieldSpec>;
}

// Mirrors packages/event-schema/schemas/events/{app_opened/v2,screen_viewed/v1,homework_opened/v1}.json
export const EVENT_SCHEMAS: Record<string, EventSpec> = {
  app_opened: {
    version: 2,
    anonymousAllowed: true,
    required: ["cold_start"],
    properties: {
      cold_start: { type: "boolean" },
      launch_source: {
        type: "string",
        enum: ["icon", "notification", "deep_link"],
      },
    },
  },
  screen_viewed: {
    version: 1,
    anonymousAllowed: true,
    required: [],
    properties: {},
  },
  homework_opened: {
    version: 1,
    anonymousAllowed: false,
    required: ["homework_to_student_id"],
    properties: {
      homework_to_student_id: { type: "integer", minimum: 1 },
    },
  },
};

// Mirrors packages/event-schema/schemas/envelope.v1.json's `context` sub-object.
export const CONTEXT_FIELD_SCHEMAS: Record<string, FieldSpec> = {
  campus_id: { type: "integer", minimum: 1 },
  grade_id: { type: "integer", minimum: 1 },
  classroom_id: { type: "integer", minimum: 1 },
  screen: { type: "string", pattern: /^[a-z0-9_]{1,64}$/ },
  locale: { type: "string", enum: ["es-MX", "en-US"] },
};
